// TODO: cleanup : Move to account component by splitting into multiple reducers if possible
import * as types from '../actionTypes/RewardsActionTypes';

function RewardsReducer(state = { rewardsDetails: { data: '' } }, action = {}) {
    switch (action.type) {
        case types.GET_REWARDS_REQUEST: {
            const details = { isLoading: true };
            return { ...state, details };
        }

        case types.GET_POINT_REQUEST:
            return Object.assign([], []);

        case types.GET_REWARDS_REQUEST_ERROR:
        case types.GET_REWARDS_REQUEST_SUCCESS: {
            const details = action.rewardsDetails;
            return { ...state, details, isSuccess: true };
        }

        case types.LINK_CREDITCARD_SUCCESS: {
            const creditCardLinkedDetails = action.linkDetails;
            const newState = { ...state, creditCardLinkedDetails };
            if (creditCardLinkedDetails.status === 200) {
                const { cardNumber } = newState.creditCardLinkedDetails;
                const lastFourDigits = cardNumber.substring(cardNumber.length - 4);
                const creditCard = {
                    lastFourDigits,
                };
                newState.details.data.creditCards.push(creditCard);
            }
            return newState;
        }

        case types.LINK_CREDITCARD_ERROR: {
            const creditCardLinkedDetails = action.error;
            return { ...state, creditCardLinkedDetails };
        }

        case types.UPDATE_REWARDS_SETTINGS: {
            const rewardsSettingsDetails = {};
            rewardsSettingsDetails.isLoading = true;
            return { ...state, rewardsSettingsDetails };
        }
        case types.UPDATE_REWARDS_SETTINGS_SUCCESS: {
            const { rewardsSettingsDetails } = action;
            const newState = { ...state, rewardsSettingsDetails };
            if (rewardsSettingsDetails.phoneNumber) {
                newState.details.data.phoneNumber = rewardsSettingsDetails.phoneNumber;
            }
            if (rewardsSettingsDetails.dateOfBirth) {
                newState.details.data.dateOfBirth = rewardsSettingsDetails.dateOfBirth;
            }
            return newState;
        }

        case types.UPDATE_REWARDS_SETTINGS_ERROR: {
            const rewardsSettingsDetails = action.error;
            return { ...state, rewardsSettingsDetails };
        }

        case types.GET_POINT_REQUEST_SUCCESS:
            return [...state, action.pointDetails.data];

        default:
            return state;
    }
}

RewardsReducer.reducerName = 'rewardsDetails';
export default RewardsReducer;
